import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface AppState {
    error?: string | null;
    token?: string | null;
    phone?: string | null;
}

const initialState: AppState = {
    error: undefined,
};

export const slice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        setLoginError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        setLoginToken: (state, action: PayloadAction<string | null>) => {
            state.token = action.payload;
        },
        setLoginPhone: (state, action: PayloadAction<string | null>) => {
            state.phone = action.payload;
        },
    },
});

export const { setLoginError, setLoginToken, setLoginPhone } = slice.actions;
export const actions = slice.actions;

export const selectLoginError = (state: RootState) => state.login.error;
export const selectLoginToken = (state: RootState) => state.login.token;
export const selectLoginPhone = (state: RootState) => state.login.phone;

export default slice.reducer;
